import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'

import { Routes, Route, BrowserRouter, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Authenticate from './pages/authenticate/Authenticate';
import Register from './pages/register/Register';
import Home from './pages/home/Home';
import OrderCreate from './pages/order-create/OrderCreate';
import OrderEdit from './pages/order-edit/OrderEdit';
import Dish from './pages/dish/Dish';

import Assume from './pages/assume/Assume';

import DetailAssume from './pages/detail-assume/DetailAssume';

import ForgotPass from './pages/forgot-password/ForgotPass';
import Initial from './pages/initial/Initial';

import PrivateRoute from './routes/PrivateRoute';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route index element={<Navigate to="/authenticate" />} />
				<Route path="/authenticate" element={<Authenticate />} />
				<Route path="/register" element={<Register />} />
				<Route path="/forgot-password" element={<ForgotPass />} />

				<Route
					path="/"
					element={
						<PrivateRoute>
							<Initial />
						</PrivateRoute>
					}
				>
					<Route
						path="/home"
						element={
							<PrivateRoute>
								<Home />
							</PrivateRoute>
						}
					/>
					<Route
						path="/dish"
						element={
							<PrivateRoute>
								<Dish />
							</PrivateRoute>
						}
					/>
					<Route
						path="/assume"
						element={
							<PrivateRoute>
								<Assume />
							</PrivateRoute>
						}
					/>
					<Route
						path="/detail-assume"
						element={
							<PrivateRoute>
								<DetailAssume />
							</PrivateRoute>
						}
					/>
					<Route
						path="/order-create"
						element={
							<PrivateRoute>
								<OrderCreate />
							</PrivateRoute>
						}
					/>
					<Route
						path="/order-edit"
						element={
							<PrivateRoute>
								<OrderEdit />
							</PrivateRoute>
						}
					/>
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
